goog.provide('el8.service.tooltip');


/**
 * Wrapper for the tooltip libraries which manages shared configuration
 * and divorces Elation tooltip clients from the details of the
 * library we are using.
 */
el8.service.tooltip = (function() {

    return {

        /* Takes the following params:
         * - 'anchor': a dom element or array of dom elements [required]
         * - 'text': the content of the tooltip (html ok)
         * - 'placement': string, see https://atomiks.github.io/tippyjs/#placement for options. [optional]
         * - 'theme': Array<'gray' | 'dark' | 'larger' | '250'> [optional]
         * - 'interactive': true, make sure you can interact with the tooltip [optional]
         * - 'showDelay': number [optional]
         * - 'hideDelay': number [optional]
         */
        create: function(spec) {
            if (!spec) {
                console.warn("tooltip.create was called without parameters. Ignoring.");
                console.trace();
                return;
            }
            if (!spec.text) {
                console.warn("tooltip.create was called without text. Ignoring.");
                console.trace();
                return;
            }
            if (!spec.anchor || !spec.anchor.length) {
                console.debug("tooltip.create was called on an empty jquery selector. Ignoring.");
                return;
            }

            var config = {
                allowHTML: true,
                content: spec.text,
                delay: [spec.showDelay || null, spec.hideDelay || null],
                interactive: !!spec.interactive,
            };

            if (spec.placement) {
                config.placement = spec.placement;
            }

            // Tagging all tooltips created via this service with `el8` theme
            // so we can target them selectively in legacy CSS and avoid
            // interfering with other tippy instances (like ones from the modern
            // side of the FE codebase)
            var theme = 'el8';
            if (spec.theme) {
                if (typeof spec.theme === 'string') {
                    theme += ' ' + spec.theme;
                } else {
                    theme += ' ' + spec.theme.join(" ");
                }
            }
            config.theme = theme;

            // Tippy treats arrays (and jquery is array like) correctly
            for (var i = 0, len = spec.anchor.length; i < len; ++i) {
                var $anchor = $(spec.anchor[i]);

                // Move title attribute to data-original-title and remove
                // to suppress browser tooltips
                if ($anchor.prop('title')) {
                    $anchor.attr('data-original-title', $anchor.prop('title'));
                    $anchor.removeAttr('title');
                }

                $anchor.addClass('has-tippy');
                tippy(spec.anchor[i], config);
            }
        },

        destroy: function($anchor) {
            if (!$anchor || !$anchor.length) { return; }
            $anchor.removeClass('has-tippy');
            for (var i = 0, len = $anchor.length; i < len; ++i) {
                if ($anchor[i]._tippy) {
                    $anchor[i]._tippy.destroy();
                }
            }
        }

    };

})();
